'use client';

import React, { FC } from 'react';
import { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import { Swiper, SwiperSlide } from 'swiper/react';

import { IReview } from '@/contentful/utils/reviews';

import IconArrowSide from './assets/icon-arrow-side.svg';
import IconLineLeft from './assets/icon-line-left-small.svg';
import PartReviewCard from './part-review-card';

import styles from './part-reviews.module.scss';

interface PartReviewsProps {
  data: {
    category: string | undefined;
    title: string | undefined;
    reviews: IReview[];
  };
}

const PartReviews: FC<PartReviewsProps> = ({ data: { category, title, reviews } }) => (
  <section className={styles.container}>
    <div className={styles.categoryContainer}>
      <IconLineLeft />
      <p className={styles.category}>{category}</p>
    </div>
    <h2 className={styles.title}>{title}</h2>
    <Swiper
      className={styles.swiperContainer}
      {...{
        modules: [Navigation],
        speed: 300,
        loop: true,
        navigation: {
          nextEl: `.${styles.reviewNext}`,
          prevEl: `.${styles.reviewPrev}`,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 60,
          },
        },
      }}
    >
      {reviews.map((slide) => (
        <SwiperSlide className={styles.swiperSlide} key={slide.title}>
          <PartReviewCard review={slide} />
        </SwiperSlide>
      ))}
    </Swiper>
    <div className={styles.reviewNavigation}>
      <div className={styles.reviewPrev}>
        <IconArrowSide />
      </div>
      <div className={styles.reviewNext}>
        <IconArrowSide />
      </div>
    </div>
  </section>
);

export default PartReviews;
